import { createColumnHelper } from '@tanstack/react-table';
import { TReportRow, TReportsStoreData } from '@westondev/tableturn-core';

export const columnHelper = createColumnHelper<TReportRow<TReportsStoreData>>();

export const ITEM_COMBO_SALES_TABLE_ID = 'main-screen-reports-table';
export const ITEM_COMBO_SALES_ROW_ID_PREFIX = 'reports-row-';
